module.exports = __webpack_public_path__ + "img/marking_bracket_wired.26372c23.png";